export default "__VITE_PUBLIC_ASSET__818acffd__"